import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import getMenuSections from '@core/reducers/menu/selectors/getMenuSections';
import extendedMenuSectionChanged from '@shopDetails/actions/extendedMenuSectionChanged';
import getIsShelvesMenuLayout from '@core/reducers/menu/selectors/getIsShelvesMenuLayout';
import { pushPage } from '@shared/actions';
import trackSectionClicked from '@shopDetails/tracking/actions/trackSectionClicked';

const mapStateToProps = createStructuredSelector({
  sections: getMenuSections,
  isShelvesMenuLayout: getIsShelvesMenuLayout,
});

const mapDispatchToProps = {
  extendedMenuSectionChanged,
  pushPage,
  trackSectionClicked,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect);
